__turbopack_context__.v({
  "checkbox": "UGSDUG_checkbox",
  "checkbox--disabled": "UGSDUG_checkbox--disabled",
  "checkmark": "UGSDUG_checkmark",
  "label": "UGSDUG_label",
  "shimmer": "UGSDUG_shimmer",
  "text-bar-sweep": "UGSDUG_text-bar-sweep",
});
